import { useState } from 'react'
import { useRecoilValue } from 'recoil'
import clsx from 'clsx'
import Decimal from 'decimal.js'
import PopupContainer from '@/components/PopupContainer'
import IconSettle from '@/components/icons/IconSettle'
import { positionDetailValue } from '@/recoil/Position'
import contractHelper from '@/api/contractHelper'
import numberFormat from '@/utils/numberFormat'
import './SettlePnlPopup.css'

export default function SettlePnlPopup({ show, hidePopupCallback = () => {} }) {
  const { totalUnsettledPnl } = useRecoilValue(positionDetailValue)
  const [isLoading, setIsLoading] = useState(false)

  const onConfirmClick = () => {
    if (isLoading) {
      return
    }
    setIsLoading(true)
    contractHelper
      .settlePnl()
      .then(hidePopupCallback)
      .finally(() => {
        setIsLoading(false)
      })
  }

  const unsettledPnl = Decimal(totalUnsettledPnl)
  return (
    <PopupContainer
      className="settle-pnl-confirmation-popup"
      show={show}
      hidePopupCallback={hidePopupCallback}
    >
      <IconSettle className="popup-main-icon" />
      <div className="popup-title">Settle P&L</div>
      <div className="popup-description">
        By doing this, we’ll move your profit or loss from perp markets into the
        USDC token balance. The settlement fee will be deducted form your near
        wallet.
        <br />
        This has no impact on your open positions.
        <br />
        <br />
        Total unsettled PnL:{' '}
        <span
          className={clsx({
            'color-positive': unsettledPnl.gt(0),
            'color-negative': unsettledPnl.lt(0)
          })}
        >
          {unsettledPnl.lt(0) ? '-' : ''}
          {numberFormat(unsettledPnl.abs().toNumber(), 'max2')}
        </span>
      </div>
      <div
        className={clsx('main-action-button noselect', {
          disabled: unsettledPnl.eq(0)
        })}
        onClick={() => !unsettledPnl.eq(0) && onConfirmClick()}
      >
        Confirm
      </div>
      <div className="text-button noselect" onClick={hidePopupCallback}>
        Cancel
      </div>
    </PopupContainer>
  )
}
